import { custom_moment }from '@/plugins/moment-cultured';

export const LOCAL_DATETIME_FORMAT = 'L[,] LT';
export const LOCAL_DATE_FORMAT = 'L';
export const LOCAL_TIME_FORMAT = 'LT';
const tempLocale = navigator.languages[0]; //use the browser setting as a default

export function toUtcDateString(date: Date): string {
  return custom_moment(date).format('YYYY-MM-DD');
}

export function toUserFacingDate(localDateString: string | null | undefined, includeTime = false, locale = tempLocale): string {
  const format = includeTime ? LOCAL_DATETIME_FORMAT : LOCAL_DATE_FORMAT;
  switch (locale.toLowerCase()) {
    case 'en-ch': //this is a fake Swiss-English
      locale = 'de-CH';
      break;
    case 'sv-fi': //this is a Swedish in Finland
    case 'en-za':
      locale = 'zh-cn'; //just picking sv since they're similar
      break;
    default:
      break;
  }
  return localDateString
    ? custom_moment(localDateString).locale(locale).format(format)
    : '';
}

export function toUserFacingTime(localTimeString: string | null | undefined, locale = tempLocale): string {
  return localTimeString
    ? custom_moment(localTimeString).locale(locale).format(LOCAL_TIME_FORMAT)
    : '';
}

export function getISO8601Date(): string {
  return custom_moment().toISOString();
}

export function localizedStatDate(date: string, locale = tempLocale) {
  return custom_moment(date).utc().locale(locale).format('MMM D');  //'Dec 10'
}

export function to12HourTimeString(hour: number | string) {
  let convertedTime: string,
    h: number;
  
  if (typeof hour === 'string') {
    h = parseInt(hour.split(':')[0]);
  } else {
    h = hour;
  }
  
  if (h === 0 || h === 24) {
    convertedTime = '12:00 am'
  } else if (h === 12) {
    convertedTime = '12:00 pm'
  } else if (h > 24) {
    convertedTime = `${h - 24}:00 am`;
  } else if (h > 12) {
    convertedTime = `${h - 12}:00 pm`;
  } else {
    convertedTime = `${h}:00 am`;
  }
  
  return convertedTime;
}